import { useEffect, useMemo } from 'react';

// material-ui
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

// project imports
import MainCard from 'components/MainCard';
import CircularWithPath from 'components/@extended/progress/CircularWithPath';

import { User } from 'types/user';
import { useGetUserModal } from 'api/user';
import UserForm from './UserForm';

interface Props {
  open: boolean;
  modalToggler: () => void;
  user?: any | null;
  onUserCreated?: (newUser: User) => void;
  currentUser?: any;
  defaultUserType?: number;
}

// ==============================|| CITY ADD / EDIT ||============================== //

export default function UserModal({ open, modalToggler, user, onUserCreated, currentUser, defaultUserType }: Props) {
  const { isLoading: loading, data: userData } = useGetUserModal(user);

  const userForm = useMemo(
    () => !loading && <UserForm key={user} user={userData || null} closeModal={modalToggler} onUserCreated={onUserCreated} currentUser={currentUser} defaultUserType={defaultUserType} />,
    // eslint-disable-next-line
    [user, loading, userData, onUserCreated, defaultUserType]
  );

  return (
    <>
      {open && (
        <Modal
          open={open}
          onClose={(event, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
            modalToggler();
          }}
          aria-labelledby="modal-city-add-label"
          aria-describedby="modal-city-add-description"
          sx={{
            '& .MuiPaper-root:focus': {
              outline: 'none'
            }
          }}
        >
          <MainCard
            sx={{
              minWidth: { xs: 320, sm: 600, md: 700, lg: 700 },
              maxWidth: 768,
              height: 'auto',
              maxHeight: 'calc(100vh - 48px)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
            modal
            content={false}
          >
            {loading ? (
              <Box sx={{ p: 5 }}>
                <Stack direction="row" sx={{ justifyContent: 'center' }}>
                  <CircularWithPath />
                </Stack>
              </Box>
            ) : (
              userForm
            )}
          </MainCard>
        </Modal>
      )}
    </>
  );
}
